// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AdminPanel.css */
.admin-panel-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  /* background-color: aqua; */
}

.admin-stats {
  margin-left: 90px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 20px;
  /* background-color: rgba(22, 7, 0, 0.459); */
}

.stat-item {
  flex: 1 1;
  min-width: 100px;
  text-align: center;
  padding: 10px;
  margin: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.admin-image {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
}

.Chart-div {
  display: flex;
  flex-direction: row; /* Align charts side by side */
  flex-wrap: wrap; /* Allow charts to wrap if needed */
  justify-content: space-around; /* Space out the charts */
  padding: 20px;
}

.chart-container {
  width: 50%; /* Adjust width for side-by-side layout */
  max-width: 400px; /* Max width for larger screens */
  margin: 10px;
  max-height: 350px; /* Set maximum height for charts */
  /* overflow: hidden; /* Hide overflow if the content exceeds max height */
} */

select {
  margin: 10px;
  padding: 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .admin-stats {
    flex-direction: column;
    align-items: center;
  }

  .stat-item {
    width: 100%;
    max-width: 300px;
  }

  .Chart-div {
    flex-direction: column; /* Stack charts vertically on small screens */
    align-items: center;
  }

  .chart-container {
    width: 100%; /* Full width on small screens */
    max-width: none; /* Remove max-width constraint */
    max-height: 300px; /* Adjust max height for small screens */
  }
}
`, "",{"version":3,"sources":["webpack://./src/Admin/AdminPanel/AdminPanel.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB,EAAE,8BAA8B;EACnD,eAAe,EAAE,mCAAmC;EACpD,6BAA6B,EAAE,yBAAyB;EACxD,aAAa;AACf;;AAEA;EACE,UAAU,EAAE,yCAAyC;EACrD,gBAAgB,EAAE,iCAAiC;EACnD,YAAY;EACZ,iBAAiB,EAAE,kCAAkC;EACrD,yEAAyE;AAC3E,EAAE;;;EAGA,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,sBAAsB,EAAE,6CAA6C;IACrE,mBAAmB;EACrB;;EAEA;IACE,WAAW,EAAE,gCAAgC;IAC7C,eAAe,EAAE,gCAAgC;IACjD,iBAAiB,EAAE,wCAAwC;EAC7D;AACF","sourcesContent":["/* AdminPanel.css */\n.admin-panel-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  /* background-color: aqua; */\n}\n\n.admin-stats {\n  margin-left: 90px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  padding: 20px;\n  /* background-color: rgba(22, 7, 0, 0.459); */\n}\n\n.stat-item {\n  flex: 1;\n  min-width: 100px;\n  text-align: center;\n  padding: 10px;\n  margin: 10px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n}\n\n.admin-image {\n  width: 50px;\n  height: 50px;\n  margin-bottom: 10px;\n}\n\n.Chart-div {\n  display: flex;\n  flex-direction: row; /* Align charts side by side */\n  flex-wrap: wrap; /* Allow charts to wrap if needed */\n  justify-content: space-around; /* Space out the charts */\n  padding: 20px;\n}\n\n.chart-container {\n  width: 50%; /* Adjust width for side-by-side layout */\n  max-width: 400px; /* Max width for larger screens */\n  margin: 10px;\n  max-height: 350px; /* Set maximum height for charts */\n  /* overflow: hidden; /* Hide overflow if the content exceeds max height */\n} */\n\nselect {\n  margin: 10px;\n  padding: 5px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .admin-stats {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .stat-item {\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .Chart-div {\n    flex-direction: column; /* Stack charts vertically on small screens */\n    align-items: center;\n  }\n\n  .chart-container {\n    width: 100%; /* Full width on small screens */\n    max-width: none; /* Remove max-width constraint */\n    max-height: 300px; /* Adjust max height for small screens */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
